// LOCAL HOST DEPLOYMENT / DEV
  export const ENV = {
    mode: 'Local'
    , production: false
    , msalConfig: {
        auth: {
            clientId: '367095ba-9c40-4244-91ab-4c2972d67aeb'
            , authority: 'https://login.microsoftonline.com/fe9c4641-3b53-43d0-af72-8f3e64d3aa05'
            , tenantId: 'fe9c4641-3b53-43d0-af72-8f3e64d3aa05'
        }
    }
    , apiConfig: {
        scopes: ['api://367095ba-9c40-4244-91ab-4c2972d67aeb/eos.api.access']
        , uri: '/api/*'
        , postLogoutRedirectUri: 'https://easyorderdev.dksh.com/'
        , redirectUri: 'https://easyorderdev.dksh.com/'
    }
    , unauthorizedConfig: {
        unauthorizedUrl: 'https://easyorderdev.dksh.com//#/unauthorized'
        , unauthorizedRedirect: 'https://easyorderdev.dksh.com/'
    }
    , redirectConfig: {
        connectPlusUrl: 'https://uat.clm.euris.com/dksh-hc'
        , connectClientUrl: 'https://flpnwc-xlgtvarz5i.dispatcher.ap1.hana.ondemand.com'
    }
  }

// LOCAL HOST DEPLOYMENT
//   export const ENV = {
//     mode: 'Local'
//     , production: false
//     , msalConfig: {
//         auth: {
//             clientId: '367095ba-9c40-4244-91ab-4c2972d67aeb'
//             , authority: 'https://login.microsoftonline.com/fe9c4641-3b53-43d0-af72-8f3e64d3aa05'
//             , tenantId: 'fe9c4641-3b53-43d0-af72-8f3e64d3aa05'
//         }
//     }
//     , apiConfig: {
//         scopes: ['api://367095ba-9c40-4244-91ab-4c2972d67aeb/eos.api.access']
//         , uri: '/api/*'
//         , postLogoutRedirectUri: 'http://localhost:8100'
//         , redirectUri: 'http://localhost:8100'
//     }
//     , unauthorizedConfig: {
//         unauthorizedUrl: 'http://localhost:8100/#/unauthorized'
//         , unauthorizedRedirect: 'http://localhost:8100'
//     }
//     , redirectConfig: {
//         connectPlusUrl: 'https://uat.clm.euris.com/dksh-hc'
//         , connectClientUrl: 'https://flpnwc-xlgtvarz5i.dispatcher.ap1.hana.ondemand.com'
//     }
//   }


// WEBPACK FOOTER //
// ./src/environment/environment.ts